import { SET_ADMINS } from "../actions/type";

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ADMINS:
      return action.payload;

    default:
      return state;
  }
};